import { toast } from 'react-toastify';
import { replaceOrAddById } from '../App/Helpers/store';

export const feedbackInitialState = {
	loading: false,
	items: [],
	form: {},
};

export const feedbackReducer = (state = feedbackInitialState, action) => {
	switch (action.type) {
		case 'FEEDBACK_ADD':
		case 'FEEDBACK_DELETE':
			return state;

		case 'FEEDBACK_EDITING':
		case 'FEEDBACK_LOADING':
			return {
				...state,
				loading: true,
			};

		case 'FEEDBACK_GET':
			return {
				...state,
				loading: false,
				items: action.payload.data.data,
			};

		case 'FEEDBACK_ERROR':
			toast.error('Virhe tietojen tallennuksessa');
			return {
				...state,
				loading: false,
			};
		case 'FEEDBACK_EDITED':
			toast.success('Tiedot tallennettu');
			return {
				...state,
				loading: false,
			};

		case 'FEEDBACKITEM_SET_LOADING':
			let nitems = [...state.items];
			let nindex = nitems.findIndex((val) => {
				// eslint-disable-next-line eqeqeq
				return val.id == action.id;
			});
			if (nindex > -1) {
				nitems[nindex].loading = true;
			}

			return {
				...state,
				items: nitems,
				loading: false,
			};

		case 'FEEDBACKITEM_GET':
			const items = replaceOrAddById(
				[...state.items],
				action.payload.data.data
			);

			return {
				...state,
				items,
				loading: false,
			};

		case 'FEEDBACKFORM_INPUT':
			return {
				...state,
				form: { ...state.form, [action.key]: action.value },
				loading: false,
			};

		case 'FEEDBACKFORM':
			return {
				...state,
				loading: true,
			};
		case 'FEEDBACKFORM_RESET':
			return {
				...state,
				loading: false,
				form: { ...action.value },
			};
		case 'FEEDBACKFORM_SUCCESS':
			return {
				...state,
				loading: false,
			};
		case 'FEEDBACKFORM_FAIL':
			toast.error('Palautteen lähettäminen epäonnistui');
			return {
				...state,
				loading: false,
			};

		default:
			return state;
	}
};
